import React from "react";
import { Link } from "react-router-dom";

const LINK = /\[([^\]]+)\]\(([^)]+)\)/g;
const cls = "underline underline-offset-2 hover:text-brand transition-colors";

const Anchor = ({ href, children }) => {
  if (href.startsWith("/")) return <Link to={href} className={cls}>{children}</Link>;
  const ext = href.startsWith("http");
  return <a href={href} className={cls} {...(ext ? { target: "_blank", rel: "noopener noreferrer" } : {})}>{children}</a>;
};

export const RichText = ({ text }) => {
  const out = [];
  let last = 0;
  for (const m of text.matchAll(LINK)) {
    out.push(text.slice(last, m.index), <Anchor key={m.index} href={m[2]}>{m[1]}</Anchor>);
    last = m.index + m[0].length;
  }
  out.push(text.slice(last));
  return <>{out}</>;
};

export default RichText;
